export function getDist(p1x, p1y, p2x, p2y) {
  let dx = p2x - p1x;
  let dy = p2y - p1y;
  return Math.sqrt(dx * dx + dy * dy);
}
export function valueMap(num, in_min, in_max, out_min, out_max) {
  num = Math.min(in_max, num);
  num = Math.max(in_min, num);
  let result =
    ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
  return result;
}
export function degToRad(deg) {
  return deg * (Math.PI / 180);
}
export function radToDeg(rad) {
  return rad * (180 / Math.PI);
}
export function clamp(number, min, max) {
  return Math.max(min, Math.min(number, max));
}

export function is_touch_device() {
  var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  var mq = function (query) {
    return window.matchMedia(query).matches;
  };
  if (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  ) {
    return true;
  }
  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
}
